import { ChangeDetectionStrategy, Component, Input, TemplateRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QPointIconModule } from '@qpoint/icons';
import { TranslateModule } from '@ngx-translate/core';
import { QPointNumberFormatPipe, QPointTranslateUnitPipe } from '@qpoint/i18n';
import { Subject } from 'rxjs';

@Component({
    selector: 'qpoint-polygon-pop-up',
    imports: [
        CommonModule,
        QPointIconModule,
        TranslateModule,
        QPointTranslateUnitPipe,
        QPointNumberFormatPipe
    ],
    templateUrl: './polygon-pop-up.component.html',
    styleUrls: ['./polygon-pop-up.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class QPointPolygonPopUpComponent {

  public scalingFactor$ = new Subject<number>;
  @Input() set scalingFactor(value: number) {
    this.scalingFactor$.next(value);
  }
  @Input() scalingFactorRequiredText: string;
  @Input() scalingFactorRequiredTemplate: TemplateRef<any>;

  @Input() circumferenceLabel: string;
  @Input() circumference: number;

  @Input() areaLabel: string;
  @Input() area: number;
}
